<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="purple">mdi-format-list-bulleted</v-icon>
      {{ t.dashboard?.available_services || 'Available Services' }}
    </v-card-title>
    <v-card-text>
      <v-progress-circular v-if="loading" indeterminate size="24" class="mr-2" />
      <div v-if="loading">{{ t.dashboard?.loading_services || 'Loading services...' }}</div>

      <v-list v-else-if="services.length > 0" density="compact">
        <v-list-item
          v-for="service in services"
          :key="service.id"
          @click="navigateToService(service)"
        >
          <template v-slot:prepend>
            <v-icon :color="getServiceTypeColor(service.service_type_name)">
              {{ getServiceTypeIcon(service.service_type_name) }}
            </v-icon>
          </template>
          <v-list-item-title>{{ service.name }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ service.service_type_name }} - {{ service.price }} {{ service.currency_code }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>

      <v-alert v-else type="info" variant="tonal" density="compact">
        {{ t.dashboard?.no_available_services || 'No available services' }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import { getAllServicesList } from '@/composables/useGetServicesAPI'
import store from '@/store'

export default {
  name: 'AvailableServicesSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      services: [],
      loading: true
    }
  },
  computed: {
    t() { return tRef.value },
    token() {
      return store.getters.getToken
    }
  },
  async mounted() {
    await this.loadServices()
  },
  methods: {
    async loadServices() {
      this.loading = true
      try {
        const result = await getAllServicesList(this.token)
        if (!result.error && result.services_list) {
          const parsed = typeof result.services_list === 'string'
            ? JSON.parse(result.services_list)
            : result.services_list
          this.services = parsed.slice(0, 10) // Show max 10 services
        }
      } finally {
        this.loading = false
      }
    },
    getServiceTypeIcon(typeName) {
      const icons = {
        'imsi': 'mdi-sim',
        'msisdn': 'mdi-phone',
        'imsi_msisdn': 'mdi-cellphone',
        'imsi_subscription': 'mdi-sim-outline',
        'client': 'mdi-account'
      }
      return icons[typeName?.toLowerCase()] || 'mdi-cog'
    },
    getServiceTypeColor(typeName) {
      const colors = {
        'imsi': 'primary',
        'msisdn': 'success',
        'imsi_msisdn': 'warning',
        'imsi_subscription': 'info',
        'client': 'purple'
      }
      return colors[typeName?.toLowerCase()] || 'grey'
    },
    navigateToService(service) {
      this.$router.push({
        path: '/clientServices',
        query: { service_id: service.id }
      })
    }
  }
}
</script>
